<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
:root{
  --home_logo: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_logo.png');
  --home_tit: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_tit.png');
  --home_icon: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_icon.png');
  --home_bg_top: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_bg_top.png');
  --home_bg_bot: url('https://h5storage.xingflash.com/modern_enroll/2025/images/home_bg_bot.png');
  --site_logo: url('https://h5storage.xingflash.com/modern_enroll/2025/images/site_logo.png');
  --site_btn_back: url('https://h5storage.xingflash.com/modern_enroll/2025/images/site_btn_back.png');
  --site_form_tit_bg: url('https://h5storage.xingflash.com/modern_enroll/2025/images/site_form_tit_bg.png');
  --enroll_disclaimer_1: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_1.png');
  --enroll_disclaimer_2: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_2.png');
  --enroll_disclaimer_3: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_3.png');
  --enroll_disclaimer_4: url('https://h5storage.xingflash.com/modern_enroll/2025/images/enroll_disclaimer_4.png');
  --rank_tit: url('https://h5storage.xingflash.com/modern_enroll/2025/images/rank_tit.png');
  --rank_cont_bg: url('https://h5storage.xingflash.com/modern_enroll/2025/images/rank_cont_bg.png');
  --rank_cont_tip: url('https://h5storage.xingflash.com/modern_enroll/2025/images/rank_cont_tip.png');
  --rank_num_1: url("https://h5storage.xingflash.com/modern_enroll_2024/images/rank_num_1.png");
  --rank_num_2: url("https://h5storage.xingflash.com/modern_enroll_2024/images/rank_num_2.png");
  --rank_num_3: url("https://h5storage.xingflash.com/modern_enroll_2024/images/rank_num_3.png");
}
body{
  background-color: #f18e2e;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue